import React, { useCallback, useState } from "react";

import ComicCard from "../../../components/ComicCard";

import { getNumberComics, fetchInitialSnapshot, fetchNextSnapshot } from "../../../utils/databaseOperations";

// Load the spinner loading icon
import InfiniteScroll from "react-infinite-scroller/dist/InfiniteScroll";
import ClipLoader from "react-spinners/ClipLoader";



const Cards = ({ className, excludeId = "none", urlPart }) => {

    // State variables for fetching comics from firestore
    const [docSnapshot, setDocSnapshot] = useState(null); 
    const [comicItems, setComicItems] = useState([]); 
    const [hasMoreComics, setHasMoreComics] = useState(true); 

    const [limitNumberComics, setLimitNumberComics] = useState(0); 
    const [initalLoading, setInitalLoading] = useState(true); 


    // Funcion para cargar comics cuando se haga scroll
    const fetchComics = useCallback(
        async () => {

            if(initalLoading){  // Si es la primera vez que carga comics entonces carga los prineros 3 comics

                let limit = await getNumberComics();
                let docSnapshots = await fetchInitialSnapshot(15);  // Cargar 15 comics

                let newComics = docSnapshots.docs.map(doc => doc.data());

                // Excluir el comicCard que ya se esta mostrando en el ComicDetailPage
                if(excludeId !== "none") {
                    newComics = newComics.filter(item => item.id !== excludeId);
                }
                console.log("elementos de lista: ", newComics)
        
                setLimitNumberComics(limit);
                setDocSnapshot(docSnapshots);
                setComicItems(comicItems.concat(newComics));
                setInitalLoading(false); // Indicar que ya no es la primera vez que carga comics

            }else{  // Si no es la primera vez, entonces carga los siguientes comics

                if(comicItems.length < limitNumberComics - 1){  // Si el número de comics desplegados es menor al limite, entonces seguir cargando comics (el -1 representa al comic que fue excluido)

                    let docSnapshots = await fetchNextSnapshot(docSnapshot, 10); // Cargar 10 comics cuando baje el scroll

                    let newComics = docSnapshots.docs.map(doc => doc.data());

                    setComicItems(comicItems.concat(newComics));
                    setDocSnapshot(docSnapshots);

                }else{  // Si no, entonces dejar de cargar comics
                    setHasMoreComics(false);
                }
            }
        },
        [comicItems, docSnapshot, initalLoading]
    );



    return (
        <InfiniteScroll
        pageStart={1}
        loadMore={fetchComics}
        hasMore={hasMoreComics}
        loader={<ClipLoader
                color={"#2688ff"}
                loading={true}
                cssOverride={{
                    display: "block",
                    margin: "75px auto",
                    borderColor: "blue",
                }}
                size={150}
                aria-label="Loading Spinner"
                data-testid="loader"
            />}
        >

            <div className={`grid ${className} items-center mx-auto px-2 py-7`}>
                {comicItems.map((item) => (
                    <ComicCard key={item.id} item={item} urlPart={urlPart} />
                ))}
            </div> 

        </InfiniteScroll>
    );
}; 

export default Cards; 